/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LanguageModel } from '../../models/language-model';

export interface LanguageIdGet$Params {
  id: string;
}

export function languageIdGet(http: HttpClient, rootUrl: string, params: LanguageIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<LanguageModel>> {
  const rb = new RequestBuilder(rootUrl, languageIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<LanguageModel>;
    })
  );
}

languageIdGet.PATH = '/Language/{id}';
